export class ClsCode {
  Code: string;
  CodigoSistema: string;
  EsNube?: boolean;
  RedirectUrl?: string;
  Proveedor?: string;
}

export class ClsAccessToken {
  AccessToken: string;
  RefreshToken?: string;
  CodigoSistema: string;
  IdSesion?: bigint;
  ZonaHoraria?: string;
  ModoLogin?: string;
  RedirectUrl?: string;
  Idioma: string;
  EsNube: boolean;
  Version: string;
}
